import { z } from 'zod';

export const searchSchema = z.object({
  dvt: z.string().optional(),
  dvt_quy_doi: z.string().optional(),
  he_so: z.string().optional().default('0.0000'),
  trang_thai: z.string().optional().default('1'),
  dvt_uuid: z.string().optional(),
  dvt0_uuid: z.string().optional()
});

export type SearchFormValues = z.infer<typeof searchSchema>;
